import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Breadcrumb, Form, Spin } from 'antd';

import HeaderSteps from 'components/HeaderSteps';
import PartnerEditForm from './PartnerEdit.form';

import deliveryRoute from '../../route';
import text from './PartnerEdit.translation';

import './PartnerEdit.style.less';

const PartnerEditFormWrapper = Form.create()(PartnerEditForm);

export class PartnerEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.partnerId = this.props.match.params.id || '';
  }

  componentDidMount() {
    const { getPartnerDetail } = this.props;

    getPartnerDetail(this.partnerId, true);
  }

  _renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    const partnerDetailPath = deliveryRoute.PARTNER_DETAIL.replace(
      ':id',
      this.partnerId,
    );

    return (
      <div className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={deliveryRoute.PARTNER_LIST}>
              {formatMessage(text.partnerManagement)}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={partnerDetailPath}>
              {formatMessage(text.partnerDetail)}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.partnerEdit)}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
    );
  };

  goToPartnerDetails = () => {
    const { history } = this.props;

    const path = deliveryRoute.PARTNER_DETAIL.replace(':id', this.partnerId);
    history.replace(path);
  };

  renderForm = () => {
    const {
      partnerDetail,
      partnerEditStep,
      loading,
      updatePartnerEditStep,
      intl,
      updatePartner,
    } = this.props;

    return (
      <PartnerEditFormWrapper
        intl={intl}
        data={partnerDetail}
        partnerEditStep={partnerEditStep}
        loading={loading}
        updatePartnerEditStep={updatePartnerEditStep}
        onCancelForm={this.goToPartnerDetails}
        updatePartner={updatePartner}
        onEditSuccess={this.goToPartnerDetails}
      />
    );
  };

  renderSpinner = () => (
    <div className="partner-edit-spin">
      <Spin tip="Loading Form" />
    </div>
  );

  renderContent = () => {
    const {
      partnerEditStep,
      intl: { formatMessage },
    } = this.props;

    return (
      <div className="white-box-wrapper">
        <div className="header-steps-container">
          <HeaderSteps
            currentStep={partnerEditStep}
            stepOneTitle={formatMessage(text.stepOneTitle)}
            stepOneDescription={formatMessage(text.stepOneDescription)}
            stepTwoTitle={formatMessage(text.stepTwoTitle)}
            stepTwoDescription={formatMessage(text.stepTwoDescription)}
            stepThreeTitle={formatMessage(text.stepThreeTitle)}
            stepThreeDescription={formatMessage(text.stepThreeDescription)}
          />
        </div>
        {this.renderForm()}
      </div>
    );
  };

  render() {
    const { getPartnerDetailLoading } = this.props;

    return (
      <div className="main-content partner-edit-main-wrapper">
        {this._renderBreadCrumb()}
        {getPartnerDetailLoading === true
          ? this.renderSpinner()
          : this.renderContent()}
      </div>
    );
  }
}

PartnerEdit.propTypes = {
  history: PropTypes.object,
  intl: PropTypes.object.isRequired,
  match: PropTypes.object,
  partnerDetail: PropTypes.object,
  getPartnerDetail: PropTypes.func,
  updatePartnerEditStep: PropTypes.func,
  updatePartner: PropTypes.func,
  getPartnerDetailLoading: PropTypes.bool,
  loading: PropTypes.bool,
  partnerEditStep: PropTypes.number,
};

export default PartnerEdit;
